"use client";
import {
  spinner_default
} from "./chunk-MSDKUXDP.mjs";
import {
  useSpinner
} from "./chunk-IKKYW34A.mjs";
export {
  spinner_default as Spinner,
  useSpinner
};
